import { render, staticRenderFns } from "./FaultDocument.vue?vue&type=template&id=3915a406"
import script from "./FaultDocument.vue?vue&type=script&lang=js"
export * from "./FaultDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports